import { render, staticRenderFns } from "./MasterPage.vue?vue&type=template&id=140930f5&scoped=true"
import script from "./MasterPage.ts?vue&type=script&lang=ts&external"
export * from "./MasterPage.ts?vue&type=script&lang=ts&external"
import style0 from "./MasterPage.vue?vue&type=style&index=0&id=140930f5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140930f5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('140930f5')) {
      api.createRecord('140930f5', component.options)
    } else {
      api.reload('140930f5', component.options)
    }
    module.hot.accept("./MasterPage.vue?vue&type=template&id=140930f5&scoped=true", function () {
      api.rerender('140930f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/Masters/pages/MasterPage/MasterPage.vue"
export default component.exports